import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import styles from './listSearchHeader.module.scss';

export default memo(function ListSearchHeader(props) {
    const [t] = useTranslation(props.dictionary);

    return (
        <div className={styles.container}>
            <Input
                className={styles.search}
                endAdornment={
                    <InputAdornment position="end">
                        <SVG cacheGetRequests className={styles.searchIcon} src="./icons/search.svg" />
                    </InputAdornment>
                }
                placeholder={t(props.text)}
                onChange={props.onChange}
            />
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.dictionary === nextProps.dictionary &&
        prevProps.text === nextProps.text &&
        prevProps.onChange === nextProps.onChange
);
